import { RefObject } from 'react';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { SubmitFormDialog } from '@shared/components/dialogs/submit-form-dialog';
import { EditClientForm, EditClient } from '../../entity';
import { useClientForm } from './client-form.hooks';
import ClientForm from './client-form';

type ClientFormDialogProps = {
  dialogRef: RefObject<ImperativeFormDialogRefType | null>;
  defaultValues?: EditClientForm['defaultValues'];
  clientId?: string;
  enableAllowedServices?: boolean;
};

const ClientFormDialog = (props: ClientFormDialogProps) => {
  const { dialogRef, defaultValues, clientId, enableAllowedServices } = props;
  const { t } = useIntlTranslations();

  const {
    createOrUpdateClientMutation,
    serviceOptions,
    isExpertPlan,
    methods,
    isRegularClient,
    validatePhoneUnique,
  } = useClientForm(Boolean(enableAllowedServices), defaultValues, clientId);

  return (
    <SubmitFormDialog<EditClient>
      ref={dialogRef}
      methods={methods}
      onSubmit={data => {
        createOrUpdateClientMutation(clientId ? { ...data, id: clientId } : data);
      }}
      title={t('clientDialog.editClient')}
    >
      {handleInputRef => (
        <ClientForm
          handleInputRef={handleInputRef}
          control={methods.control}
          isRegularClient={isRegularClient}
          isExpertPlan={isExpertPlan}
          serviceOptions={serviceOptions}
          validatePhoneUnique={validatePhoneUnique}
        />
      )}
    </SubmitFormDialog>
  );
};

export default ClientFormDialog;
